import classNames from 'classnames'
import { Component } from 'preact'
import globals from '../../utils/globals'
import userAvatar from '../../utils/userAvatar'
import LazyLoader from '../lazy-loading/LazyLoader'
import ProfilePopup from '../profile-popup/index'

export interface UserAvatarProps<WithRank extends boolean|undefined> {
  user: {
    id: number|string
    name: string
    avatar?: string
    url?: string
    rank?: WithRank extends true ? {
      avatarIconUrl?: string
      name: string
    } | null : undefined
  }
  extraClass?: string
  disablePopup?: boolean
  showRank?: WithRank
  disableLink?: boolean
  openInNewTab?: boolean
  style?: JSX.HTMLAttributes['style']
}

interface State {
  ref: boolean
  disablePopup: boolean
  disableLink: boolean
}

class UserAvatar<WithRank extends boolean|undefined> extends Component<UserAvatarProps<WithRank>, State> {
  ref: HTMLElement|undefined
  constructor (props: UserAvatarProps<WithRank>) {
    super(props)

    this.state = {
      ref: false,
      disablePopup: (typeof window !== 'undefined' && window.inSidedData?.device !== 'desktop') || !!props.disablePopup,
      disableLink: !!props.disableLink
    }
  }

  componentDidMount () {
    this.setState({ ref: true })
  }

  generateUserUrl (user: UserAvatarProps<WithRank>['user']) {
    if (globals('application') === 'control') {
      return `/member/profile?userid=${user.id}`
    }
    return `/members/${user.name.toLowerCase()}-${user.id}`
  }

  render () {
    const { user, extraClass, showRank, style, openInNewTab } = this.props
    const { disablePopup, disableLink } = this.state

    if (user.id) {
      return (
        <div className={classNames('avatar', extraClass)} style={{ float: 'none', ...style }}>
          <div className='profilepicture qa-profile-picture' ref={r => { this.ref = r }}>
            <a className='default-avatar-link qa-topic-meta-last-user-icon' href={disableLink ? undefined : user.url ? user.url : this.generateUserUrl(user)} target={openInNewTab ? '_blank' : undefined} rel='noreferrer'>
              {userAvatar.isDefaultAvatar(user.avatar)
                ? <div className={classNames('default-avatar', userAvatar.getAvatarClass(user.id))}>
                  {userAvatar.getAvatarInital(user.name)}
                </div>
                : <LazyLoader type='img' src={user.avatar || ''} style={{ width: '100%' }} alt={user.name} />}
              {showRank && user.rank && user.rank.avatarIconUrl
                ? <div className='profilelabel qa-profile-label'><img src={user.rank.avatarIconUrl} alt={user.rank.name} title={user.rank.name} /></div>
                : null}
            </a>
            {
            this.state.ref && !disablePopup && (
              <ProfilePopup
                hoverControl={this.ref}
                memberId={typeof user.id === 'number' ? user.id : parseInt(user.id)}
              />
            )
          }
          </div>
        </div>
      )
    }
    return (
      <div className={classNames('avatar', extraClass)} style={({ float: 'none', ...style })}>
        <div className='profilepicture qa-profile-picture default-avatar-link qa-topic-meta-last-user-icon default-cursor'>
          <div className={classNames('default-avatar', userAvatar.getAvatarClass(user.id))}>
            {userAvatar.getAvatarInital(user.name)}
          </div>
        </div>
      </div>
    )
  }
}

export default UserAvatar
